<template>
    <!-- 定点投放-投放类目列表 -->
    <div class="container">
        <div class="handle-box-search">
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button @click="addBtn('add')">新增投放类目</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="类目名称" prop="name" min-width="130"> </el-table-column>

            <!-- <el-table-column label="是否上架" prop="" min-width="100">
                <template slot-scope="scope">
                    <div>
                        <el-switch
                            v-model="scope.row.is_open"
                            active-value="1"
                            inactive-value="0"
                            @change="changePromotionCategoryStatus(scope.row)"
                        >
                        </el-switch>
                    </div>
                </template>
            </el-table-column> -->

            <el-table-column label="创建时间" prop="insert_time_stamp" min-width="180"> </el-table-column>

            <el-table-column width="280px" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" trigger="click" @click="editBtn(scope.row, 'edit')"> 编辑 </el-button>
                    <el-button type="danger" trigger="click" @click="deleteBtn(scope.row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 新增类目组件 -->
        <addCategory :isShow="category_isShow" :data="editData" @onSubmit="searchPromotionCategoryLists"></addCategory>
    </div>
</template>

<script>
var _this;

import addCategory from './addCategory.vue';

import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    components: {
        addCategory
    },
    data() {
        return {
            editData: {},
            category_isShow: false,

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10
            },

            result_data: {},

            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchPromotionCategoryLists();
    },

    methods: {
         // 新增投放类目
        addBtn(e) {
       
            _this.editData.editFlag = e;
            _this.category_isShow = !_this.category_isShow;
        },
        // 编辑
        editBtn(e, val) {
            _this.editData.editFlag = val;
            _this.editData.promotion_category_code = e.promotion_category_code;
            _this.editData.promotion_category_color = e.promotion_category_color;
            _this.editData.name = e.name;
            _this.category_isShow = !_this.category_isShow;
        },
         // 上架下架
        // changePromotionCategoryStatus(val) {
        //     _this
        //         .$post('/promotion/changePromotionCategoryStatus', {
        //             promotion_category_code: val.promotion_category_code,
        //             is_open: val.is_open
        //         })
        //         .then((res) => {
        //             _this.$message.success(res.msg);
        //             _this.promotionCategoryLists();
        //         })
        //         .catch((err) => {});
        // },
        // 列表
        promotionCategoryLists() {
            _this
                .$post('/promotion/promotionCategoryLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                 
                    _this.tableData = res.data;

                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        // 列表删除
        deleteBtn(scope) {
            this.$confirm('您确认要删除吗？删除后，类目将作废！请慎重操作！ 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this
                        .$post('/promotion/deletePromotionCategory', {
                            promotion_category_code: scope.promotion_category_code
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);

                            _this.promotionCategoryLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.promotionCategoryLists();
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
          // 搜索
        searchPromotionCategoryLists() {
            _this.search_data.page = 1;
            _this.promotionCategoryLists();
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.promotionCategoryLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
